import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const emptySplitApi = createApi({
  baseQuery: fetchBaseQuery({
    //prepare headers work need to be done
    prepareHeaders: async (headers, { getState }) => {
      try {
        const token = getState().auth?.userDetail?.access;
        console.log("token",token)
        // headers.set("Content-Type", "application/json");
        // headers.set("Accept", "application/json");
        if (token) {
          headers.set("Authorization", `JWT ${token}`);
        } else {
          headers.set("Authorization", "");
        }
      } catch (err) {
        headers.set("Authorization", "");
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
  tagTypes: [
    "getLanguage",
    "languageTranslationQuery",
    "getClientProjects",
    "getClientSites",
    "getClientZones",
    "companyPermission",
    "newRole",
    "managementCompanyList",
    "getCompany",
    "getFunctions",
    "getDepartments",
    "getEntities",
    "getUsers",
    "permissionsList",
    "getClients",
    "getSites",
    "userListDropDown",
    "managerDropDown",
    "reportToDropDown",
    "companyRolePermission",
    "nativeOtherLangaugesDropdown",
    "entityDropdown",
    "getTopicCerts",
  ],
});
